import Users from "../components/Users";
import TopNav from "../components/TopNav";
import Sidebar from "../components/SideNav";
import Footer from "../components/Footer";
import AddUser from "../components/AddUser";
const AddUserPage = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <div className="sticky-top z-3">
        <TopNav />
      </div>
      <div className="d-flex flex-grow-1 overflow-hidden">
        <aside style={{

            position: "sticky",
            //top: '20px', // match navbar height
            height: "calc(100vh - 120px)",
          }}
        >
          <Sidebar />
        </aside>
        <main className="w-100">
          <AddUser/>
        </main>
      </div>
      <div className="sticky-bottom z-3">
        <Footer />
      </div>
    </div>
  );
};
export default AddUserPage;
